exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_error_message{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:column;flex-direction:column;margin:10px 0;padding:16px;border:1px solid #ccc;background-color:#eee;-webkit-animation:FadeInAnimation 1s ease;animation:FadeInAnimation 1s ease}.table_error_message span{color:#ff0000;font-weight:bold;margin-left:auto;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/errorBoundary/tableErrorMessage/TableErrorMessage.style.scss
// module id = 1589
// module chunks = 0